import { useState, useRef, useEffect } from "react";

type EditableTextProps = {
  value: string;
  onCommit: (newValue: string) => void;
  className?: string;
};

const EditableText = ({
  value,
  onCommit,
  className = "",
}: EditableTextProps) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [draft, setDraft] = useState<string>(value);
  const inputRef = useRef<HTMLInputElement>(null);

  // Sync when external value changes
  useEffect(() => {
    setDraft(value);
  }, [value]);

  // Focus input on edit mode
  useEffect(() => {
    if (isEditing) {
      inputRef.current?.focus();
    }
  }, [isEditing]);

  const handleSave = () => {
    if (draft !== value) {
      onCommit(draft.trim());
    }
    setIsEditing(false);
  };

  const handleCancel = () => {
    setDraft(value);
    setIsEditing(false);
  };

  return isEditing ? (
    <input
      ref={inputRef}
      value={draft}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={handleSave}
      onKeyDown={(e) => {
        if (e.key === "Enter") handleSave();
        if (e.key === "Escape") handleCancel();
      }}
      className={`w-full h-full select-none items-center text-center focus:outline-0 focus:border focus:border-gray-400 focus:bg-gray-200
         ${className}`}
    />
  ) : (
    <span
      onClick={() => setIsEditing(true)}
      className={`cursor-text select-none ${className}`}
    >
      {value}
    </span>
  );
};

export { EditableText };
